export const briefModalDescription =
    "מתכננים אירוע? כאן תוכלו לבנות בריף לבית עסק אחד או יותר ולקבל הצעת מחיר מותאמת לאירוע שלכם. מומלץ למלא כמה שיותר פרטים שההצעה תיהיה מדויקת";
